import type { Tenant as ApiTenant } from '../types/tenant.types';
import type { TenantTableRow } from '../types/tenant.types';


export function mapTenantToTable(
  tenant: ApiTenant & { primary_domain?: string | null },
): TenantTableRow {

  return {
    id: String(tenant.id),

    name: tenant.name,

    primaryDomain: tenant.primary_domain ?? null,

    plan: '-',

    usersCount: 0,

    servicesCount: 0,

    createdAt: '-',

    status: tenant.status,

    ...(tenant.representative_mobile !== undefined
      ? { representativeMobile: tenant.representative_mobile }
      : {}),
  };
}
